import { c as _c } from "react/compiler-runtime";
import { animated } from '@react-spring/web';
import React, { FunctionComponent, PropsWithChildren } from 'react';
import { Direction, SlideInWithBackdrop } from '../../animation/SlideInWithBackdrop/SlideInWithBackdrop';
import { FixedContentPortal } from '../../fixedContent/FixedContentPortal/FixedContentPortal';
import { IconDeprecated, IconType } from '../../misc/IconDeprecated/IconDeprecated';
import { prepareProps } from '../../utils/propUtils';
import { classes } from '../../utils/utils';
import styles from './SidebarWithBackdrop.module.css';
export enum Side {
  Left = 'left',
  Right = 'right',
}
export type SidebarWithBackdropProps = PropsWithChildren<{
  opened: boolean;
  /**
   * default: left
   */
  side?: Side;
  /**
   * this is called when something occured which wants to close the sidebar
   */
  onCloseSidebar: () => void;
  'data-testid'?: string;
}>;

/**
 * the content will be placed in a flex layout
 */
export const SidebarWithBackdrop: FunctionComponent<SidebarWithBackdropProps> = React.memo(props => {
  const $ = _c(14);
  let t0;
  if ($[0] !== props) {
    t0 = prepareProps({
      props
    });
    $[0] = props;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const {
    children,
    opened,
    side: t1,
    "data-testid": testid,
    onCloseSidebar
  } = t0;
  const side = t1 === undefined ? Side.Left : t1;
  const t2 = sideToAnimationDirection[side];
  let t3;
  if ($[2] !== children || $[3] !== onCloseSidebar || $[4] !== side || $[5] !== testid) {
    t3 = (slideStyle, backdropStyle) => <FixedContentPortal><animated.div className={styles.backdrop} style={backdropStyle} onClick={onCloseSidebar} data-testid="SidebarWithBackdrop.backdrop" /><animated.aside className={classes(styles.aside, sideToAsideClassName[side])} style={slideStyle} data-testid={`${testid ? `${testid}.` : ""}SidebarWithBackdrop.ContentWrapper`}><div className={styles.header}><IconDeprecated name="times" type={IconType.Light} className={styles.headerIcon} onClick={onCloseSidebar} /><span className={styles.headerCompanyName}>recordIT</span></div>{children}</animated.aside></FixedContentPortal>;
    $[2] = children;
    $[3] = onCloseSidebar;
    $[4] = side;
    $[5] = testid;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== opened || $[8] !== t2 || $[9] !== t3) {
    t4 = <SlideInWithBackdrop show={opened} direction={t2}>{t3}</SlideInWithBackdrop>;
    $[7] = opened;
    $[8] = t2;
    $[9] = t3;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  let t5;
  if ($[11] !== t4 || $[12] !== testid) {
    t5 = <div className={styles.placeholder} data-testid={testid}>{t4}</div>;
    $[11] = t4;
    $[12] = testid;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  return t5;
});
const sideToAsideClassName: Record<Side, string> = {
  left: styles.asideLeft,
  right: styles.asideRight
};
const sideToAnimationDirection: Record<Side, Direction> = {
  left: Direction.LeftToRight,
  right: Direction.RightToLeft
};